import { FC } from 'react';
import { withStyles, MaterialSymbol } from 'vopay';
import styles from './StatusIcon.module.scss';

type StatusIconProps = {
  status: 'pending' | 'successful' | 'failed' | 'approval-rejected';
  size: 'small' | 'medium';
};

const cn = withStyles(styles);

const StatusIcon: FC<StatusIconProps> = ({ status = 'pending', size = 'medium' }) => {
  return (
    <div className={cn('icon', size, status)}>
      {status !== 'pending' && (
        <MaterialSymbol icon={status === 'successful' ? 'check' : status === 'failed' ? 'close' : 'error'} />
      )}
    </div>
  );
};

export default StatusIcon;
